import { Stack, Typography } from '@mui/material';
import React from 'react';

type ChargeEditDrawerContentSectionProps = React.PropsWithChildren<{
  title?: React.ReactNode;
}>;

export const ChargeEditDrawerContentSection: React.FC<ChargeEditDrawerContentSectionProps> = ({
  title,
  children,
}) => {
  return (
    <Stack direction="column" sx={{
      rowGap: 2
    }}>
      {React.isValidElement(title) ? title : <Typography variant="subtitle1">{title}</Typography>}
      {children}
    </Stack>
  );
};
